// extracted by mini-css-extract-plugin
module.exports = {"root":"Drawer_root__hwrZ_","show":"Drawer_show__XUrZ4","drawerOverlay":"Drawer_drawerOverlay__2teFy","nav":"Drawer_nav__WKR4n","overlay":"Drawer_overlay__NR4Sn"};